import NextImage from "next/image"
import React, { FC } from "react"

import { create } from "src/helpers/bem"

import styles from "./DefaultImage.module.scss"

const bem = create(styles, "DefaultImage")

export interface DefaultImageProps {}

export const DefaultImage: FC<DefaultImageProps> = () => (
  <NextImage
    unoptimized
    alt={""}
    className={bem()}
    // width={}
    fill={true}
    src={"/MB-logo_vertical_blue.png"}
  />
)
